import React from 'react'
import { FxIconProps } from './FxIcon.props'

/**
 *
 * @param icon
 * @param className
 * @constructor
 */
export const FxIcon = ({
  icon,
  className,
  style,
  onClick
}: FxIconProps) => {
  const onClickIcon = () => {
    if (onClick) {
      onClick();
    }
  }
  return icon ?
    <span className={className} onClick={onClickIcon}>
      <i style={style} className={icon} />
    </span>
    :
    <></>
}
